/**
 * FondsFinder for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
import Handlebars from 'handlebars';
import _ from 'lodash';
import moment from 'moment';
//import Tablesaw from 'tablesaw';
import AMApp from '../../global/app';

export default class FondsFinder {
  /**
   * FondsFinder constructor
   *
   * @param {HTMLElement} element - The fondsFinder container element
   * @param {Object} options - Configuration options
   */
  constructor(element, options = {}) {
    console.log('FondsFinder');
    this.element = element;
    this.amApp = new AMApp();

    this.settings = Object.assign({
      routeQuickSearch: AMApp.langGetParam + 'eID=fonds&function=instant&search=',
      routeFondsFinderCategory: AMApp.langGetParam + 'eID=fonds&function=category',
      routeFondsFinderSearch: AMApp.langGetParam + 'eID=fonds&function=fondsfinder&'
    }, options);

    // State
    this.timeoutId = null;
    this.hasResult = null;

    // Messages
    this.fondsFinderNoResult = AMApp.isGerman
      ? 'Keine Fonds zu Ihrer Auswahl gefunden!'
      : 'No fonds found to your selection!';

    // DOM Elements
    this.inputDirectSearch = null;
    this.directSearchResult = null;
    this.directSearchResultTarget = null;
    this.directSearchButton = null;
    this.form = null;
    this.resultContainer = null;
    this.resultTarget = null;
    this.resetButton = null;
    this.statusInit = null;
    this.statusNoResult = null;

    this.init();
  }

  /**
   * Initialize
   */
  init() {
    this.registerHandlebarsHelpers();
    this.cacheDOM();
    this.attachEventListeners();
    this.getCategories();
    this.setupInitialState();
  }

  /**
   * Register Handlebars helpers
   */
  registerHandlebarsHelpers() {
    Handlebars.registerHelper("sqlTimeToDate", (value) => {
      if (value) {
        return moment(value).utc().format('DD.MM.YYYY');
      }
      return value;
    });

    Handlebars.registerHelper("euroAfterValue", (value) => {
      if (value) {
        value = parseFloat(value);
        return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      }
      return value;
    });
  }

  /**
   * Cache DOM elements
   */
  cacheDOM() {
    this.inputDirectSearch = this.element.querySelector('input[name="direct_search"]');
    this.directSearchResult = document.getElementById('direct_search_result');
    this.directSearchResultTarget = document.getElementById('direct_search_result_target');
    this.directSearchButton = document.getElementById('direct_search_button');
    // Read once: on the start page the template sits inside the result target and is replaced by the first render.
    const directSearchTemplate = document.getElementById('direct_search_result_template');
    this.directSearchResultRaw = directSearchTemplate ? directSearchTemplate.innerHTML : '';
    this.form = document.querySelector('[name=fondsfinder]');
    this.resultContainer = document.getElementById('fonds_result_container');
    this.resultTarget = document.getElementById('fondsfinder_result_target');
    this.resetButton = document.getElementById('fondsfinder_reset');
    this.statusInit = document.querySelector('.js_status_init');
    this.statusNoResult = document.querySelector('.js_status_noresult');
  }

  /**
   * Setup initial state
   */
  setupInitialState() {
    // Initially hide search results from tab navigation
    if (this.directSearchResultTarget) {
      const links = this.directSearchResultTarget.querySelectorAll('a');
      links.forEach(link => link.setAttribute('tabindex', '-1'));
    }

    // Setup Insti vs Retail
    if (this.amApp.isInstitutionell()) {
      this.setInstiFondsFinder();
    } else {
      this.setRetailFondsFinder();
    }
  }

  /**
   * Set fondsFinder as insti
   */
  setInstiFondsFinder() {
    const mindestanlageCheckbox = document.getElementById('mindestanlage');
    const chkMindestanlage = document.getElementById('chk_mindestanlage');
    const chkRetailfonds = document.getElementById('chk_retailfonds');

    if (mindestanlageCheckbox) {
      mindestanlageCheckbox.checked = true;
    }
    if (chkMindestanlage) {
      chkMindestanlage.remove();
    }
    if (chkRetailfonds) {
      chkRetailfonds.style.display = 'block';
    }
  }

  /**
   * Set fondsFinder as retail
   */
  setRetailFondsFinder() {
    const chkMindestanlage = document.getElementById('chk_mindestanlage');
    const chkRetailfonds = document.getElementById('chk_retailfonds');

    if (chkMindestanlage) {
      chkMindestanlage.style.display = 'block';
    }
    if (chkRetailfonds) {
      chkRetailfonds.remove();
    }
  }

  /**
   * Attach event listeners
   */
  attachEventListeners() {
    // Keyup on direct search
    if (this.inputDirectSearch) {
      this.inputDirectSearch.addEventListener('keyup', (e) => {
        this.handleDirectSearchKeyup(e);
      });

      this.inputDirectSearch.addEventListener('click', () => {
        this.handleDirectSearchFocus();
      });

      this.inputDirectSearch.addEventListener('focus', () => {
        this.handleDirectSearchFocus();
      });
    }

    // "Retailfonds" changes the quick search target group, so discard its results.
    const retailfondsCheckbox = document.getElementById('retailfonds');
    if (retailfondsCheckbox) {
      retailfondsCheckbox.addEventListener('change', () => {
        this.hasResult = false;
        if (this.directSearchResult) {
          this.directSearchResult.classList.remove('hasresult');
        }
      });
    }

    // Reset button
    if (this.resetButton) {
      this.resetButton.addEventListener('click', () => {
        setTimeout(() => this.resetFormAndResult(), 250);
      });
    }

    // Click outside to close dropdowns
    document.addEventListener('click', (e) => {
      if (!e.target.closest('#fondsfinder_direct_search') &&
        !e.target.closest('#direct_search_result')) {
        if (this.directSearchResult) {
          this.directSearchResult.classList.remove('hasresult');
        }
      }

      if (!e.target.closest('#instantsearch')) {
        const searchResult = document.getElementById('search_result');
        if (searchResult) {
          searchResult.classList.remove('search-result__active');
        }
      }
    });

    // Form submit
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        const formData = new FormData(this.form);
        const queryString = new URLSearchParams(formData).toString();

        const formObject = {
          type: this.form.getAttribute('method'),
          url: this.form.getAttribute('action'),
          data: queryString
        };

        this.getFonds(formObject);
        this.showLoadingStatus();

        return false;
      });
    }
  }

  /**
   * Handle direct search keyup
   */
  handleDirectSearchKeyup(event) {
    clearTimeout(this.timeoutId);
    const value = event.target.value;

    if (value.length > 0) {
      this.timeoutId = setTimeout(() => {
        this.getQuickSearchResult(value);
      }, 500);
    } else {
      // Hide results and make them non-tabbable
      if (this.directSearchResult) {
        this.directSearchResult.classList.remove('hasresult');
      }
      if (this.directSearchResultTarget) {
        const links = this.directSearchResultTarget.querySelectorAll('a');
        links.forEach(link => link.setAttribute('tabindex', '-1'));
      }
      this.hasResult = false;
    }
  }

  /**
   * Handle direct search focus
   */
  handleDirectSearchFocus() {
    if (this.hasResult && this.directSearchResult) {
      this.directSearchResult.classList.add('hasresult');
    } else if (!this.hasResult && this.inputDirectSearch && this.inputDirectSearch.value) {
      // Results were discarded, e.g. after toggling "Retailfonds": search again.
      this.getQuickSearchResult(this.inputDirectSearch.value);
    }
  }

  /**
   * Whether the institutional "Retailfonds" option is checked
   */
  isRetailfondsChecked() {
    const retailfondsCheckbox = document.getElementById('retailfonds');
    return retailfondsCheckbox ? retailfondsCheckbox.checked : false;
  }

  /**
   * Get quick search result
   */
  async getQuickSearchResult(searchInput) {
    if (this.directSearchButton) {
      this.directSearchButton.style.display = 'none';
    }

    // Add loader if not exists
    if (this.inputDirectSearch && !this.inputDirectSearch.nextElementSibling?.classList.contains('loader')) {
      this.inputDirectSearch.insertAdjacentHTML('afterend', AMApp.LOADING_ANIMATION);
    }

    try {
      // The instant search returns retail funds unless another target is requested (A: all funds).
      let target = 'R';
      if (this.amApp.isInstitutionell()) {
        target = this.isRetailfondsChecked() ? 'A' : 'I';
      }
      const response = await fetch(AMApp.basePath + this.settings.routeQuickSearch + searchInput + '&target=' + target);
      if (!response.ok) throw new Error('Network response was not ok');

      const result = await response.json();
      if (result) {
        setTimeout(() => {
          this.renderQuickSearchResult(result);
        }, 150);
      }
    } catch (error) {
      console.error('Error fetching quick search:', error);
      this.removeLoader();
    }
  }

  /**
   * Render quick search result
   */
  renderQuickSearchResult(result) {
    if (!this.amApp.isInstitutionell()) {
      result = this.amApp.getRetailFonds(result);
    } else if (!this.isRetailfondsChecked()) {
      result = this.amApp.getInstiFonds(result);
    }

    console.log('renderQuickSearchResult', result);

    // Remove highlighting strings
    result = result.map(doc => {
      const temp = document.createElement('div');
      temp.innerHTML = doc['INSD_NAME'];
      doc['INSD_NAME'] = temp.textContent || temp.innerText;
      temp.innerHTML = doc['INSD_ISIN'];
      doc['INSD_ISIN'] = temp.textContent || temp.innerText;
      return doc;
    });

    if (!this.directSearchResultTarget) return;

    if (result.length > 0) {
      if (this.directSearchResultRaw) {
        const directSearchResultTemplate = Handlebars.compile(
          this.amApp.toHandlebarsDelimiters(this.directSearchResultRaw)
        );
        const directSearchResult = directSearchResultTemplate({ data: result });
        this.directSearchResultTarget.innerHTML = directSearchResult;

        // Make search result links tabbable
        const links = this.directSearchResultTarget.querySelectorAll('a');
        links.forEach(link => link.removeAttribute('tabindex'));
      }
    } else {
      this.directSearchResultTarget.innerHTML = `<p>${this.fondsFinderNoResult}</p>`;
    }

    if (this.directSearchButton) {
      this.directSearchButton.style.display = 'block';
    }
    if (this.directSearchResult) {
      this.directSearchResult.classList.add('hasresult');
    }
    this.hasResult = true;
    this.removeLoader();
  }

  /**
   * Get categories for dropdowns
   */
  async getCategories() {
    const currentUrl = AMApp.basePath + this.settings.routeFondsFinderCategory;

    try {
      const response = await fetch(currentUrl);
      if (!response.ok) throw new Error('Network response was not ok');

      const result = await response.json();
      this.populateDropdowns(result);
    } catch (error) {
      console.error('Error fetching categories:', error);
      this.removeLoader();
    }
  }

  /**
   * Populate the dropdowns
   */
  populateDropdowns(data) {
    Object.entries(data).forEach(([index, value]) => {
      let processedValue = value;

      // Sort Fondsart
      if (index === 'Fondsart') {
        processedValue = value.sort();
      }

      // Filter Waehrung
      if (index === 'Waehrung') {
        processedValue = _.remove(value, (current) => {
          return !/fristig/.test(current);
        });
      }

      // Populate dropdown
      const dropdown = document.getElementById(index.toLowerCase());
      if (dropdown) {
        processedValue.forEach(entry => {
          if (entry !== 'CHF' && entry !== 'Luxemburg' && entry !== 'Schweiz' && entry !== 'Rohstofffonds') {
            const option = document.createElement('option');
            option.value = entry;
            option.textContent = entry;
            dropdown.appendChild(option);
          }
        });
      }
    });
  }

  /**
   * Get the fonds
   */
  async getFonds(formObject) {
    let parameter = formObject.data;
    const mindestanlageCheckbox = document.getElementById('mindestanlage');
    const retailfondsCheckbox = document.getElementById('retailfonds');
    const mindestanlage = mindestanlageCheckbox ? mindestanlageCheckbox.checked : false;
    const retailfonds = retailfondsCheckbox ? retailfondsCheckbox.checked : false;

    if (!this.amApp.isInstitutionell() && !mindestanlage) {
      parameter += '&mindestanlage=';
    } else if (this.amApp.isInstitutionell() && retailfonds) {
      // Retail funds have no minimum investment, so request all funds and filter them on render.
      parameter += '&mindestanlage=';
    } else if (this.amApp.isInstitutionell()) {
      parameter += '&mindestanlage=1';
    }

    const request = AMApp.basePath + this.settings.routeFondsFinderSearch + parameter;

    try {
      const response = await fetch(request);
      if (!response.ok) throw new Error('Network response was not ok');

      const result = await response.json();
      if (result) {
        if (result.length > 0) {
          this.renderFondsFinderResult(result);
        } else {
          this.showNoResultMessage();
        }
      }
    } catch (error) {
      console.error('Error fetching fonds:', error);
    }
  }

  /**
   * Render fondsFinder result
   */
  renderFondsFinderResult(result) {
    const retailfondsCheckbox = document.getElementById('retailfonds');
    const mindestanlageCheckbox = document.getElementById('mindestanlage');

    const retailfonds = retailfondsCheckbox ? retailfondsCheckbox.checked : false;
    const mindestanlage = mindestanlageCheckbox ? mindestanlageCheckbox.checked : false;

    if (!this.amApp.isInstitutionell() && !mindestanlage) {
      result = this.amApp.getRetailFonds(result);
    } else if (this.amApp.isInstitutionell() && !retailfonds) {
      result = this.amApp.getInstiFonds(result);
    } else if (this.amApp.isInstitutionell()) {
      // Institutional funds as without the option (with minimum investment) plus all retail funds.
      result = result.filter(fonds => fonds.INSD_ZIELGRUPPE === 'R'
        || (fonds.INSD_ZIELGRUPPE === 'I' && fonds.INSD_MINDESTANLAGE != null));
    }

    if (result.length === 0) {
      this.showNoResultMessage();
      return;
    }

    result = _.orderBy(result, ['INSD_NAME'], ['asc']);

    const templateEl = document.getElementById('fondsfinder_result_template');
    if (templateEl && this.resultTarget) {
      const fondsFinderResultRaw = templateEl.innerHTML;
      const fondsFinderResultTemplate = Handlebars.compile(
        this.amApp.toHandlebarsDelimiters(fondsFinderResultRaw)
      );

      this.resultTarget.innerHTML = fondsFinderResultTemplate({ docs: result });

      if (this.resultContainer) {
        this.resultContainer.classList.add('fondsresult-content__open');

        // Scroll to results
        this.resultContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (this.statusInit) {
      this.statusInit.classList.add('d-none');
    }
    if (this.statusNoResult) {
      this.statusNoResult.classList.add('d-none');
    }

    this.removeLoader();

    // Init Tablesaw for responsive tables
    if (window.innerWidth < 1024) {
      setTimeout(() => {
        // Tablesaw.init();
      }, 250);
    }
  }

  /**
   * Show no result message
   */
  showNoResultMessage() {
    if (this.statusInit) {
      this.statusInit.classList.remove('d-block');
    }
    if (this.statusNoResult) {
      this.statusNoResult.classList.remove('d-none');
    }
    // Clear only the rows; the container also holds the result table.
    if (this.resultTarget) {
      this.resultTarget.innerHTML = '';
    }
    if (this.resultContainer) {
      this.resultContainer.classList.remove('fondsresult-content__open');
    }
    this.removeLoader();
  }

  /**
   * Reset form and result
   */
  resetFormAndResult() {
    if (this.form) {
      const selects = this.form.querySelectorAll('select');
      selects.forEach(select => {
        select.selectedIndex = 0;
      });
    }

    // Clear only the rows; the container also holds the result table.
    if (this.resultTarget) {
      this.resultTarget.innerHTML = '';
    }
    if (this.resultContainer) {
      this.resultContainer.classList.remove('fondsresult-content__open');
    }

    if (this.resetButton) {
      this.resetButton.classList.add('d-none');
    }
    if (this.statusInit) {
      this.statusInit.classList.add('d-none');
    }
    if (this.statusNoResult) {
      this.statusNoResult.classList.add('d-none');
    }
  }

  /**
   * Show loading status
   */
  showLoadingStatus() {
    if (this.statusInit) {
      this.statusInit.insertAdjacentHTML('beforebegin', AMApp.LOADING_ANIMATION);
    }
    if (this.resetButton) {
      this.resetButton.classList.remove('d-none');
    }
    if (this.statusInit) {
      this.statusInit.classList.add('d-none');
    }
  }

  /**
   * Remove loader elements
   */
  removeLoader() {
    document.querySelectorAll('.loader').forEach(loader => loader.remove());
  }

  /**
   * Destroy the FondsFinder instance
   */
  destroy() {
    clearTimeout(this.timeoutId);
    this.removeLoader();
  }
}
